/* KULT Paket 43 (24.10.2026): Mega-Menü (Hover mit Verzögerung, Tastatur, Touch) und Akkordeon im mobilen Vollbild-Menü. */
(function () {
  if (window.KMN) return; window.KMN = true;
  var BP = 1280;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)');
  var root = document.documentElement;
  var openItem = null, tIn = 0, tOut = 0;

  function items() { return [].slice.call(document.querySelectorAll('[data-kmn-item].kmn-item--panel')); }
  function btn(i) { return i.querySelector('[data-kmn-toggle]'); }
  function wide() { return window.innerWidth >= BP; }

  function open(i) {
    clearTimeout(tOut);
    if (openItem === i || !wide()) return;
    var prev = openItem; openItem = i;
    if (prev) { prev.classList.remove('is-open'); btn(prev).setAttribute('aria-expanded', 'false'); }
    i.classList.add('is-open'); btn(i).setAttribute('aria-expanded', 'true');
    root.classList.add('kmn-open');
  }
  function close(i) {
    i = i || openItem; if (!i) return;
    i.classList.remove('is-open'); btn(i).setAttribute('aria-expanded', 'false');
    if (openItem === i) { openItem = null; root.classList.remove('kmn-open'); }
  }
  function closeLater() { clearTimeout(tIn); clearTimeout(tOut); tOut = setTimeout(function () { close(); }, 220); }

  function init() {
    var list = items();
    if (!list.length) return;
    var scrim = document.createElement('div'); scrim.className = 'kmn-scrim'; scrim.setAttribute('aria-hidden', 'true');
    document.body.appendChild(scrim);
    scrim.addEventListener('click', function () { close(); });

    list.forEach(function (li) {
      var a = li.querySelector('.kmn-link'), b = btn(li), p = li.querySelector('[data-kmn-panel]');
      li.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !wide()) return;
        clearTimeout(tOut); clearTimeout(tIn);
        tIn = setTimeout(function () { open(li); }, openItem ? 0 : 90);
      });
      li.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(tIn); closeLater();
      });
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (li.classList.contains('is-open')) close(li); else open(li);
      });
      /* Touch (Tablet quer): erster Tipp öffnet das Panel, zweiter folgt dem Link */
      a.addEventListener('click', function (e) {
        if (fine.matches || !wide()) return;
        if (!li.classList.contains('is-open')) { e.preventDefault(); open(li); }
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && li.classList.contains('is-open')) {
          e.preventDefault();
          var inside = document.activeElement && li.contains(document.activeElement) && document.activeElement !== a && document.activeElement !== b;
          var target = inside ? b : a;
          close(li); target.focus();
          /* Impulse blendet den Fokus bei Escape per keyup aus (Suche): danach erneut setzen */
          var re = function () { document.removeEventListener('keyup', re, true); setTimeout(function () { target.focus(); }, 20); };
          document.addEventListener('keyup', re, true);
        } else if (e.key === 'ArrowDown' && (e.target === a || e.target === b)) {
          e.preventDefault(); open(li);
          var f = p.querySelector('a[href]'); if (f) setTimeout(function () { f.focus(); }, 30);
        }
      });
      li.addEventListener('focusout', function (e) {
        if (!e.relatedTarget || !li.contains(e.relatedTarget)) { if (li.classList.contains('is-open')) closeLater(); }
      });
      li.addEventListener('focusin', function () { clearTimeout(tOut); });
    });

    document.addEventListener('click', function (e) { if (openItem && !openItem.contains(e.target)) close(); });
    window.addEventListener('resize', function () { if (!wide()) close(); });
    window.addEventListener('scroll', function () { if (openItem && window.scrollY < 0) close(); }, { passive: true });
  }

  /* Akkordeon im Vollbild-Menü */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-kmn-acc]'); if (!t) return;
    var p = document.getElementById(t.getAttribute('aria-controls')); if (!p) return;
    var on = t.getAttribute('aria-expanded') !== 'true';
    var scope = t.closest('.kmn-dr__list');
    if (on && scope) {
      scope.querySelectorAll('[data-kmn-acc][aria-expanded="true"]').forEach(function (o) {
        if (o !== t) { o.setAttribute('aria-expanded', 'false'); var q = document.getElementById(o.getAttribute('aria-controls')); if (q) q.classList.remove('is-open'); }
      });
    }
    t.setAttribute('aria-expanded', on ? 'true' : 'false'); p.classList.toggle('is-open', on);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
